import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { RootReducerState } from 'redux/reducers';

// @ts-ignore
import styles from './site.module.scss';

export const FooterComponent = () => {
  const year = new Date().getFullYear();
  const serverAlias = useSelector((state: RootReducerState) => state.global.serverAlias);
  const serverVersion = useSelector((state: RootReducerState) => state.global.serverVersion);

  return (
    <footer className={styles.footer}>
      <Row className={styles.row}>
        <Col lg={3} xs={12} className="align-self-center text-left text-sm-left pt-1">
          <Link to="/Privacy">Privacy Policy</Link>
          {' | '}
          <Link to="/Accessibility">Accessibility Information</Link>
        </Col>
        <Col lg={9} xs={12} className="align-self-center text-left text-sm-left text-lg-right pt-1">
          © Copyright 2013 -
          {' '}
          {year}
          {' '}
          Created for the Office of Medical Marijuana Use by Five Points Technology
          Group - All Rights Reserved.
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col xs={12} className="text-left text-sm-left text-lg-right pt-1">
          {serverVersion && serverAlias && (
            <>
              <span>{`v${serverVersion}`}</span>
              {' - '}
              <span>{`${serverAlias}`}</span>
            </>
          )}
        </Col>
      </Row>
    </footer>
  );
};
